export const AUTO_PAUSE_WARNING_THRESHOLD = 0.8
